const NAMESPACE = "editAutomation";

const KEYS = {
    triggerHeader: "triggerHeader",
    addProgramWideActionText: "addProgramWideActionText",
    addActionText: "addActionText",
    addValidationText: "addValidationText",
    addProgramActionText: "addProgramActionText",
    editProgramWideActionText: "editProgramWideActionText",
    editActionText: "editActionText",
    editValidationText: "editValidationText",
    editProgramActionText: "editProgramActionText",
    enableAutomationPopUpText: "enableAutomationPopUpText",
    enableAutomationYes: "enableAutomationYes",
    enableAutomationNo: "enableAutomationNo",
    statusActionCascadingError: "statusActionCascadingError",
    unreachableActionRuleError: "unreachableActionRuleError"
};

const MESSAGES = {
    [KEYS.triggerHeader]: {
        value: "Trigger",
        comment: "Header for the trigger section"
    },
    [KEYS.addProgramWideActionText]: {
        value: "Add Program Wide Project Action Rule",
        comment: "Header for the trigger section"
    },
    [KEYS.addActionText]: {
        value: "Add Action Rule",
        comment: "Header for the trigger section"
    },
    [KEYS.addValidationText]: {
        value: "Add Validation Rule",
        comment: "Header for the trigger section"
    },
    [KEYS.addProgramActionText]: {
        value: "Add Program Action Rule",
        comment: "Header for the trigger section"
    },
    [KEYS.editProgramWideActionText]: {
        value: "Edit Program Wide Project Action Rule",
        comment: "Header for the trigger section"
    },
    [KEYS.editActionText]: {
        value: "Edit Action Rule",
        comment: "Header for the trigger section"
    },
    [KEYS.editValidationText]: {
        value: "Edit Validation Rule",
        comment: "Header for the trigger section"
    },
    [KEYS.editProgramActionText]: {
        value: "Edit Program Action Rule",
        comment: "Header for the trigger section"
    },
    [KEYS.enableAutomationPopUpText]: {
        value: "Enable this automation?",
        comment: "Pop-up text for enabling"
    },
    [KEYS.enableAutomationYes]: {
        value: "Yes",
        comment: "Pop-up text for enabling"
    },
    [KEYS.enableAutomationNo]: {
        value: "No",
        comment: "Pop-up text for enabling"
    },
    [KEYS.statusActionCascadingError]: {
        value:
            "Status Action Rules are not allowed on status exit or transition Triggers." +
            " Some of the Action Rules in this Automation will violate this and will be ignored.",
        comment: "Error message for when a status does not allow cascading and a status action is selected"
    },
    [KEYS.unreachableActionRuleError]: {
        value:
            "Rule #{ruleOrder} is defined to run every time this automation is triggered and then stop the automation." +
            " Subsequent actions will never be executed.",
        comment:
            "Error message when there are unreachable action rules in the automation;" +
            " The {ruleOrder} parameter is the displayed order value of the rule that stops the automation."
    }
};

export { KEYS, NAMESPACE, MESSAGES };
